import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { useTheme } from '@mui/material';
import getSVGIconToggleColor from '../../../../utils/svg-icons';
import { CustomSvgIconProps, ToggleColorType } from '../../../../types/domain/svg-icons';

export default function TruckBIcon(props: CustomSvgIconProps): JSX.Element {
  const defaultColor = useTheme().palette.primary.dark;
  const color = props.htmlColor || defaultColor;
  return (
    <SvgIcon
      {...props}
      htmlColor={color}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      titleAccess="truck b">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12z"
        fill={getSVGIconToggleColor(ToggleColorType.background, props.toggle!!)}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.888 8.5c-.11 0-.2.083-.2.187v7.297h2.345c.244-.628.886-1.076 1.639-1.076.657 0 1.23.341 1.527.846.297-.505.87-.846 1.528-.846.753 0 1.394.448 1.639 1.076h.235c.11 0 .2-.084.2-.188v-7.11c0-.103-.09-.187-.2-.187h-8.713zm8.478 8.609h.235c.772 0 1.398-.588 1.398-1.313v-7.11c0-.724-.626-1.312-1.398-1.312h-8.713c-.772 0-1.398.588-1.398 1.313v.652c0 .104-.089.188-.2.188h-.985c-.542 0-1.034.294-1.265.754l-1.062 2.127a.197.197 0 01-.128.1l-1.826.474c-.606.157-1.025.675-1.025 1.265v1.55c0 .724.625 1.312 1.397 1.312h1c.244.628.885 1.076 1.638 1.076.753 0 1.395-.448 1.64-1.076h4.359c.244.628.886 1.076 1.639 1.076.657 0 1.23-.342 1.527-.847.297.505.87.847 1.528.847.753 0 1.394-.448 1.639-1.076zM8.673 15.984h.817v-5.346a1.492 1.492 0 01-.2.014h-.985a.2.2 0 00-.18.107l-1.063 2.127c-.173.347-.5.605-.893.707l-1.826.474a.19.19 0 00-.147.18v1.55c0 .103.09.187.2.187h1c.244-.628.885-1.076 1.638-1.076.753 0 1.395.448 1.64 1.076zm-1.639.048c-.302 0-.547.23-.547.514 0 .284.245.514.547.514.302 0 .547-.23.547-.514 0-.284-.245-.514-.547-.514zm7.638 0c-.302 0-.547.23-.547.514 0 .284.245.514.547.514.302 0 .546-.23.546-.514 0-.284-.244-.514-.546-.514zm3.055 0c-.302 0-.547.23-.547.514 0 .284.245.514.547.514.302 0 .546-.23.546-.514 0-.284-.244-.514-.546-.514z"
        fill={getSVGIconToggleColor(ToggleColorType.highlighted, props.toggle!!)}
      />
    </SvgIcon>
  );
}
